"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
//@ts-ignore
require("../theme.ts");
var Menu = /** @class */ (function (_super) {
    __extends(Menu, _super);
    function Menu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.clickHandler = function (item) {
            if (!item.disabled) {
                _this.fire('selected', item);
            }
        };
        return _this;
    }
    Menu.prototype.render = function (props) {
        var _this = this;
        return (omi_1.h("div", __assign({}, omi_1.extractClass(props, 'mdc-menu mdc-menu-surface'), { tabIndex: -1 }),
            omi_1.h("ul", { class: "mdc-list", role: "menu", "aria-hidden": "true", "aria-orientation": "vertical" }, props.list.map(function (item) { return omi_1.h("li", { onClick: function (_) { return _this.clickHandler(item); }, class: "mdc-list-item", role: "menuitem" },
                omi_1.h("span", { class: omi_1.classNames('mdc-list-item__text', {
                        'mdc-list-item--disabled': item.disabled
                    }) }, item.text)); }))));
    };
    Menu.css = css;
    Menu.defaultProps = {};
    Menu.propTypes = {
        list: Object
    };
    Menu = __decorate([
        omi_1.tag('m-menu')
    ], Menu);
    return Menu;
}(omi_1.WeElement));
exports.default = Menu;
